class Bus {
  list: { [key: string]: Array<any> };

  static instance: any;

  constructor() {
    this.list = {};
  }

  $on(name: string, fn: any) {
    this.list[name] = this.list[name] || [];
    this.list[name].push(fn);
  }

  $emit(name: string, data?: any) {
    if (this.list[name]) {
      this.list[name].forEach((fn: any) => {
        fn(data);
      });
    }
  }

  $off(name: string) {
    if (this.list[name]) {
      delete this.list[name];
    }
  }

  // 静态方法: 获取实例(单例)
  static getInstance() {
    if(!this.instance) {
      this.instance = new Bus();
    }
    return this.instance;
  }
}
export default Bus.getInstance();
